import { render, staticRenderFns } from "./ShoppingTable.vue?vue&type=template&id=22ca9e8d"
import script from "./ShoppingTable.vue?vue&type=script&lang=js"
export * from "./ShoppingTable.vue?vue&type=script&lang=js"
import style0 from "./ShoppingTable.vue?vue&type=style&index=0&id=22ca9e8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports